// @flow
import * as React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import styles from './DrawerMenu.styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TopBarSocialIcons from 'app/components/TopBarSocialIcons';
import SearchBox from 'app/components/SearchBox';
import drawerToggle from 'app/redux/actions/drawerToggle';

type Props = {
  classes: any,
  theme: any,
  menuList: Array<any>
};

type State = {
  open: boolean
};

class DrawerMenu extends React.Component<Props, State> {
  handleDrawerOpen = () => {
    this.props.dispatch(drawerToggle('open'));
  };

  handleDrawerClose = () => {
    this.props.dispatch(drawerToggle('close'));
  };

  render() {
    const { classes, theme, isOpen } = this.props;
    return (
      <Hidden mdUp>
        <div className={classes.buttonHolder}>
          <IconButton
            color="inherit"
            aria-label="Open Main Menu"
            onClick={this.handleDrawerOpen}
            className={classNames(classes.menuButton, isOpen && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <SwipeableDrawer
          open={isOpen}
          onClose={this.handleDrawerClose}
          onOpen={this.handleDrawerOpen}
          anchor="left"
          classes={{paper: classes.drawerPaper}}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>
          <Divider />
          <div className={classes.searchWrapper}>
            <SearchBox className={classes.searchBox} />
            <Divider />
          </div>
          <List className={classes.menu}>
            {this.props.menuList.map(item => (
              <ListItem
                  button
                  key={item.term_id}
                  component={Link}
                  className={classNames(classes.menuItem, classes[`style_${item.term_id}`])}
                  to={`/category/${item.term.slug}`}
                  onClick={this.handleDrawerClose}
                >
                <ListItemText primary={item.term.name} />
              </ListItem>
            ))}
          </List>
          <div className={classes.socialIconsWrapper}>
            <Divider />
            <TopBarSocialIcons className={classes.socialIcons} />
          </div>
        </SwipeableDrawer>
      </Hidden>
    );
  }
}

const mapStateToProps = state => ({
  menuList: state.menu,
  navigation: state.navigation,
  isOpen: state.drawerToggle === 'open'
});

const componentWithStyles = withStyles(styles, {withTheme: true})(DrawerMenu);
const Component = connect(mapStateToProps)(componentWithStyles);
export {Component as DrawerMenu};
export default Component;